import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
// import * as Cookies from 'js-cookie';
// import axios from 'axios';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import modules from './modules';

Vue.use(Vuex);

//Used in local storage
const userProfileState = createPersistedState({
  paths: ['authentication', 'brand']
});

// Snapshot initial module states before Vuex makes them reactive
// so resetAllState can restore them later (initialState() is private to each module)
const initialModuleStates = {};
for (const moduleName in modules) {
  const moduleState = modules[moduleName].state;
  if (moduleState) {
    initialModuleStates[moduleName] = JSON.parse(JSON.stringify(moduleState));
  }
}

export default new Vuex.Store({
  state: {
    defaultLanguage: 'en',
    navDrawerOpen: false,
    ksStatus: null,
    impersonating: false
  },

  actions: {
    ...actions,

    resetAllState({ state }) {
      for (const moduleName in initialModuleStates) {
        if (state[moduleName]) {
          const freshState = JSON.parse(JSON.stringify(initialModuleStates[moduleName]));
          Object.keys(freshState).forEach(key => {
            Vue.set(state[moduleName], key, freshState[key]);
          });
        }
      }
      // Reset root state
      state.navDrawerOpen = false;
      state.ksStatus = null;
      state.impersonating = false;
    }
  },
  mutations,
  getters,
  modules,
  plugins: [userProfileState]
});
